module.exports = __webpack_public_path__ + "static/logo-f563f7a4b26056256fcae9936912b649.svg";